import { render, staticRenderFns } from "./CustomerComplaintQuality.vue?vue&type=template&id=4e8593ac&"
import script from "./CustomerComplaintQuality.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports